// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"2b6e6ceb","345":"0e38e4a1","386":"959ea527","453":"68693753","566":"e1633b77","790":"05010f9e","794":"71813f37","847":"59f4b8a0","851":"4025cf63","936":"fc03faf5","946":"364cfb6a"}[chunkId] + ".chunk.js";
};